import { createAction, createSlice } from "@reduxjs/toolkit";

const getMyCoursesSlice = createSlice({
  name: "getMyCourses",
  initialState: { data: [], processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data, pagination } = action.payload;
      state.data = data.data;
      state.pagination = pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getMyCoursesSlice;
const getMyCoursesAction = createAction(name);

export {
  getMyCoursesAction,
  actions as getMyCoursesActions,
  reducer as getMyCoursesReducer,
};
